import React from 'react';

const EtchEndCap = (props) => {

  const opts = props?.opts || {};
  const { id } = opts;

  return (
    <div className="etch-analytics" data-module-id={id} id="top-deals__wrapper" />
  );
};

export default EtchEndCap;
